import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=3f34c2d3&scoped=true&"
import script from "./Upgrade.vue?vue&type=script&lang=js&"
export * from "./Upgrade.vue?vue&type=script&lang=js&"
import style0 from "./Upgrade.vue?vue&type=style&index=0&id=3f34c2d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f34c2d3",
  null
  
)

export default component.exports